import {
    useRef,
    useState
} from 'react';
import {
    Container,
    Content,
    AvatarWrapper,
    Body,
    Input,
    Actions,
    LoadingProgress
} from './styled';
import {
    Avatar,
    InputPhone,
    Switch
} from '../../components';
import { useChat } from '../../contexts/chat';
import {
    postAccessibilityByPhone
} from '../../service/serviceChat/chatService';
import {
    newContact
} from '../../service/serviceChat/chatService';
import { IoIosClose } from 'react-icons/io';
import { FaCheck } from "react-icons/fa";
import { toast } from 'react-toastify';
import LoadCreate from '../../assets/gif/Mz9UGRlMjA.gif';

export function ContactNew(props) {

    const {
        onBack,
        onLoadContacts
    } = props;
    const {
        functionality
    } = useChat();

    const refInputName = useRef(null);

    const [contact, setContact] = useState({
        name: '',
        phone: '',
        idd: ''
    });
    const [switchState, setSwitchState] = useState(false);
    const [loading, setLoading] = useState(false);

    const onWaitingTime = (callback) => {
        const timeoutId = setTimeout(() => {
            callback();
        }, 2000);
        return () => clearTimeout(timeoutId);
    };

    const phoneFormatted = (idd, phone) => {
        return `${idd.replace("+", "")}${phone.replace(/\D/g, '')}`
    };
    async function handSave() {
        setLoading(true);
        if (!contact?.name.trimStart()) {
            toast.warn(
                'Informe um nome para o contato !',
                { position: "top-center", theme: "colored" }
            );
            return setLoading(false);
        }
        if (!contact?.phone.trimStart()) {
            toast.warn(
                'Informe um numero de contato !',
                { position: "top-center", theme: "colored" }
            );
            return setLoading(false);
        }
        const contactCreated = await newContact(
            contact.name,
            phoneFormatted(contact.idd, contact?.phone)
        );
        const { status, message } = contactCreated;
        if (status === 'error') {
            toast.error(
                `${message}`,
                { position: "top-center", theme: "colored" }
            );
            return setLoading(false);
        }
        const { cliente } = contactCreated;
        if (switchState) {
            const isAccessibilityUpdated = await postAccessibilityByPhone(
                cliente?.number_client,
                1
            );
            if (!isAccessibilityUpdated) {
                toast.error(
                    `Erro ao atualizar acessibilidade`,
                    { position: "top-center", theme: "colored" }
                );
                return setLoading(false);
            };
        }
        onWaitingTime(
            () => {
                onLoadContacts();
                setLoading(false);
                onBack(cliente);
                toast.success(
                    `${message}`,
                    { position: "top-center", theme: "colored" }
                );
            }
        );
    };

    return (
        <>
            <Container isLoading={loading ? 1 : 0}>
                <Content>
                    <div className='xtR'>
                        <AvatarWrapper>
                            <div>
                                <Avatar
                                    name={contact?.name}
                                    width={'100%'}
                                    height={'100%'}
                                    fontSize={'2.5rem'}
                                />
                            </div>
                            <span onClick={() => onBack()}>
                                <IoIosClose fontSize={`2.5rem`} />
                            </span>
                        </AvatarWrapper>
                    </div>
                    <Body>
                        <div>
                            <Input
                                ref={refInputName}
                                id='nameContact'
                                name={'nameContact'}
                                value={contact?.name}
                                disabled={loading}
                                onChange={(e) => {
                                    setContact((prevContact) => ({
                                        ...prevContact,
                                        name: e.target.value,
                                    }));
                                }}
                                placeholder='Nome Completo'
                            />
                        </div>
                        <div>
                            <InputPhone
                                id='phoneContact'
                                name={'phoneContact'}
                                value={contact?.phone}
                                disabled={loading}
                                onChange={(idd, phone) => {
                                    setContact((prevContact) => ({
                                        ...prevContact,
                                        idd: idd,
                                        phone: phone,
                                    }));
                                }}
                            />
                        </div>
                        <div>
                            {functionality.includes('somente_audio') &&
                                (<Switch
                                    label={`Enviar somente audio`}
                                    disabled={loading}
                                    checked={switchState}
                                    onChange={() => setSwitchState(!switchState)}
                                />)
                            }
                        </div>
                    </Body>
                    <Actions>
                        <button
                            className="btn--delete-cancel"
                            onClick={() => { onBack() }}
                        >
                            {`Cancelar`}
                        </button>
                        <button
                            className="btn--save"
                            onClick={() => handSave()}
                        >
                            <span>
                                <FaCheck fontSize={`1.5rem`} />
                            </span>
                            {`Salvar`}
                        </button>
                    </Actions>
                </Content>
            </Container>
            <LoadingProgress isOpen={loading ? 1 : 0}>
                <div>
                    <img
                        src={LoadCreate}
                        alt="load--"
                    />
                    <p>
                        {`Criando contato ...`}
                    </p>
                </div>
            </LoadingProgress>
        </>
    );
}